import { useRef } from 'react';
import { Animated } from 'react-native';

export function useFade({ duration, value = 1 }: { duration: number; value?: number }): {
  opacity: Animated.AnimatedValue;
  fadeIn: Animated.CompositeAnimation;
  fadeOut: Animated.CompositeAnimation;
} {
  const opacity = useRef<Animated.AnimatedValue>(new Animated.Value(0)).current;
  const fadeIn = useRef<Animated.CompositeAnimation>(
    Animated.timing(opacity, {
      duration: duration,
      toValue: value,
      useNativeDriver: false,
    }),
  ).current;
  const fadeOut = useRef<Animated.CompositeAnimation>(
    Animated.timing(opacity, {
      duration: duration,
      toValue: 0.0,
      useNativeDriver: false,
    }),
  ).current;

  return { opacity, fadeIn, fadeOut };
}

export function useSlide({ duration, value }: { duration: number; value: number }): {
  translateY: Animated.AnimatedValue;
  slideUp: Animated.CompositeAnimation;
  slideDown: Animated.CompositeAnimation;
} {
  const translateY = useRef<Animated.AnimatedValue>(new Animated.Value(value)).current;

  const slideUp = useRef<Animated.CompositeAnimation>(
    Animated.spring(translateY, {
      toValue: 0, // translate to a zero offset (its natural position)
      useNativeDriver: false,
    }),
  ).current;
  const slideDown = useRef<Animated.CompositeAnimation>(
    Animated.timing(translateY, {
      duration,
      toValue: value, // translate by current height, so the entire thing moves off-screen
      useNativeDriver: false,
    }),
  ).current;

  return { translateY, slideUp, slideDown };
}
